import React, { ReactNode, useContext } from 'react';
import cls from 'classnames';
import { MyContext } from '@/config/context-manager';

import styles from './style.module.scss';

type ThemeType = 'default' | 'allWhite' | 'green';
interface TitleProps {
  className?: string;
  theme?: ThemeType;
  id?: string;
  children: ReactNode;
}

const Title: React.FC<TitleProps> = ({ className, children, theme = 'default', id }) => {
  const { locale } = useContext(MyContext);
  const classes = cls(styles.container, className, styles[`${theme}`], {
    [styles.localeEn]: locale === 'en',
  });
  return (
    <div className={classes} id={id}>
      <h3 className={styles.content}>{children}</h3>
    </div>
  );
};

export default Title;
